import * as types from "../../actions/ActionTypes";

const initialState = {
  loading: false,
  data: null,
  error: null,
};

const initiatePaymentReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.INITIATE_PAYMENT_START:
      return { ...state, loading: true, data: null, error: null };
    case types.INITIATE_PAYMENT_SUCCESS:
      return { ...state, loading: false, data: action.payload };
    case types.INITIATE_PAYMENT_ERROR:
      return { ...state, loading: false, error: action.payload };
    case types.INITIATE_PAYMENT_RESET:
      return initialState;
    default:
      return state;
  }
};

export default initiatePaymentReducer;
